/**
 * Marks a dashboard URL as "the user just submitted the personalization
 * form".
 *
 * The dashboard's AuthGate reads `personalization_completed` off the user to
 * decide whether to send them here, and the stamp we just wrote is not always
 * visible to that read by the time they land — so without this they bounce
 * straight back and have to submit again, re-sending the CRM lead every lap.
 *
 * It has to be a URL parameter rather than shared storage: the portal and the
 * dashboard are different origins (`account.` vs `dashboard.`), so localStorage
 * and sessionStorage are not shared between them.
 *
 * Deliberately only set after a SUBMIT. Marking the outbound redirect instead
 * would let anyone skip the step by ignoring it once.
 */
export const personalizedReturnUrl = (dashboardUrl: string) => {
  try {
    const url = new URL(dashboardUrl);
    url.searchParams.set('personalized', '1');
    return url.toString();
  } catch {
    // A relative or malformed target isn't worth failing the redirect over —
    // the user still gets to the dashboard, just without the marker.
    return dashboardUrl;
  }
};
